import PropTypes from 'prop-types';
import React from 'react';
import { useDrop } from 'react-dnd'

const propTypes = {
  handleSetTree: PropTypes.func,
  acceptChildren: PropTypes.array,
};

export default function DndCardDrop({ path, id, handleSetTree, acceptChildren }) {
  const [{ isOver, canDrop }, dropReference] = useDrop(() => ({
    accept: acceptChildren,
    drop(item, monitor) {
      const action = item.path() === 'pallet' ? 'add' : 'move'
      const from = item.path()
      const fromPosition = item.id
      const to = path
      const toPosition = 'card'

      handleSetTree(action, { from, fromPosition, to, toPosition, item, extra: 'addLastPosition' })
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }))

  return <div className={`${canDrop && !isOver ? 'twy-bg-base-accent' : ''} w-full h-18`} ref={dropReference}>
    {!canDrop && <div className="flex shrink py-6 px-4 w-full items-center justify-center twy-subtle-neutral border rounded twy-text-base-accent border-dashed">
      Drag and drop the components creating a structure that represents the api's response.
    </div>}
    {isOver && <div className="h-1 w-full rounded twy-bg-accent" />}
  </div>
}

DndCardDrop.propTypes = propTypes
DndCardDrop.defaultProps = {}
